import { AppStore } from 'store/app/types'
import { AppActionTypes } from 'store/app/actions/types'
import { SUBSCRIBE_ERROR, SUBSCRIBE_START, SUBSCRIBE_SUCCESS } from 'store/app/actions/subscribe'
import { UPDATE_OPPORTUNITY_ID } from 'store/app/actions/updateOpportunityId'
import { GET_PRODUCTS, GET_PRODUCTS_ERROR, GET_PRODUCTS_SUCCESS } from './actions/getProducts'
import { SET_SELECTED_PRODUCER } from './actions/setSelectedProducer'

const initialState: AppStore = {
  isLoading: false,
  error: false
}

export const reducer = (state = initialState, action: AppActionTypes): AppStore => {
  switch (action.type) {
    case GET_PRODUCTS:
    case SUBSCRIBE_START:
      return {
        ...state,
        isLoading: true,
        error: false
      }

    case GET_PRODUCTS_SUCCESS: {
      const { products } = action

      return {
        ...state,
        isLoading: false,
        error: false,
        products
      }
    }

    case SET_SELECTED_PRODUCER: {
      const { producer } = action

      return {
        ...state,
        isLoading: false,
        error: false,
        selectedProducer: producer
      }
    }

    case SUBSCRIBE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        opportunityId: action.opportunityId
      }

    case UPDATE_OPPORTUNITY_ID:
      return {
        ...state,
        opportunityId: action.opportunityId
      }

    // ERRORS

    case GET_PRODUCTS_ERROR:
    case SUBSCRIBE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true
      }

    default:
      return state
  }
}
